import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/partner/')({
  component: () => <Navigate to="/partner/mapping" />,
});
